import { useContext } from "react";
import { PlatformContext } from "../contexts/PlatformContext/PlatformContext";

export function useUserRanksAndPoints(){
    const {
        globalRank,
        globalRankIncrease,
        schoolRank,
        schoolRankIncrease,
        points,
        coinsCount,
    } = useContext(PlatformContext)

    return {
        globalRank,
        globalRankIncrease,
        schoolRank,
        schoolRankIncrease,
        points,
        coins: coinsCount
    }
}